import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button } from "semantic-ui-react";

const BlockGallery = props => (
  <div>
    {props.options.map(option => (
      <Button
        active={props.block[props.dataKey] === option}
        className="ed-gallery-item"
        key={option}
        onClick={_ => {
          /**
           * Performs a copy of the block and updates
           * its text
           */
          const block = { ...props.block };
          block[props.dataKey] = option;

          /**
           * Passes on the block update to the higher-order
           * component
           */
          props.onChange(block);
        }}
      >
        <img
          src={`assets/galleries/${props.prefix}.${option}-150w.png`}
          alt=""
        />
        <b>
          <FormattedMessage id={`${props.prefix}.${option}`} />
        </b>
      </Button>
    ))}
  </div>
);

BlockGallery.propTypes = {
  /**
   * block: {text}
   * Contains the content block information
   */
  block: PropTypes.shape({
    text: PropTypes.string
  }).isRequired,

  /**
   * options: [String]
   * Contains all the options of the gallery
   */
  options: PropTypes.arrayOf(PropTypes.string).isRequired,

  /**
   * onChange: updatedBlock => ()
   * Passes on a block update to the higher-level component
   */
  onChange: PropTypes.func.isRequired,

  /**
   * dataKey: String
   * Key, under which the entered text is stored within the block
   */
  dataKey: PropTypes.string,

  /**
   * prefix: String
   * String prefix that is added before all option keys
   */
  prefix: PropTypes.string.isRequired
};

BlockGallery.defaultProps = {
  dataKey: "type"
};

export default BlockGallery;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/ui/BlockGallery.js